export const SIDES = {
	IN: 'IN',
	OUT: 'OUT'
}